import { ModuleWithProviders, Provider } from '@angular/core';
import { DwMenuService } from './service/menu.service';
import { DwRecursiveMenuService } from './service/recursive-menu.service';
// import { DwRecursiveMenuStorageService } from './service/recursive-menu-storage.service';
import { DwMenuLangLoaderService } from './service/menu-lang-loader.service';
import { DwMenuAttributeService } from './service/menu-attribute.service';
import { DwMenuExecuteService } from './service/menu-execute.service';
import { DW_LANG_LOADER } from '../../config/system.config';
var DwMenusModule = /** @class */ (function () {
    function DwMenusModule() {
    }
    DwMenusModule.forRoot = function (providers) {
        return {
            ngModule: DwMenusModule,
            providers: [
                DwMenuService,
                DwRecursiveMenuService,
                // DwRecursiveMenuStorageService,
                // 選單翻譯檔載入器
                DwMenuLangLoaderService,
                {
                    provide: DW_LANG_LOADER,
                    useExisting: DwMenuLangLoaderService,
                    multi: true
                },
                DwMenuAttributeService,
                DwMenuExecuteService
            ].concat(providers)
        };
    };
    return DwMenusModule;
}());
export { DwMenusModule };
